module.exports = __webpack_public_path__ + "static/media/transfer.ed080081.svg";